export function submitNewBankAccountSourceFromPaysimple({ handleClose }) {
  return (dispatch, getState) => {
    const state = getState();
    const { resident, organization } = state;
    const {
      routing_number,
      account_number,
      account_holder_type,
      account_holder_name,
      company_name,
    } = state.newPaymentSourceForm;

    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources/create_pay_simple_bank_account.json`,
      method: "POST",
      data: {
        payment_source: {
          kind: "bank_account",
          routing_number,
          account_number,
          account_holder_type,
          account_holder_name,
          company_name,
        },
      },
      success: (response) => {
        dispatch({ type: "ADD_PAYMENT_SOURCE", payload: response });
        dispatch({ type: "SUCCESS_SUBMIT_NEW_PAYMENT_SOURCE" });
        handleClose();
      },
      error: (xhr) => {
        const errors = $.parseJSON(xhr.responseText).error;
        dispatch({
          type: "FAILED_SUBMIT_NEW_PAYMENT_SOURCE",
          payload: [errors],
        });
      },
    });
  };
}

export function submitNewCardPaymentSourceFromPaySimple({
  handleClose,
  paySimple,
}) {
  return (dispatch, getState) => {
    const state = getState();
    const { resident, organization } = state;

    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources/create_pay_simple_card.json`,
      method: "POST",
      data: {
        payment_source: {
          kind: "card",
          pay_simple_token_id: paySimple.payment_method_token,
        },
      },
      success: (response) => {
        dispatch({ type: "ADD_PAYMENT_SOURCE", payload: response });
        dispatch({ type: "SUCCESS_SUBMIT_NEW_PAYMENT_SOURCE" });
        handleClose();
      },
      error: (xhr) => {
        const errors = $.parseJSON(xhr.responseText).errors;
        dispatch({ type: "FAILED_SUBMIT_NEW_PAYMENT_SOURCE", payload: errors });
      },
    });
  };
}

export function submitNewPaymentSourceFromStripe({
  stripe,
  handleClose,
  paySimple,
}) {
  return (dispatch, getState) => {
    const state = getState();
    const { resident, organization } = state;
    const {
      first_name,
      last_name,
      email,
      card_number,
      kind,
      routing_number,
      account_number,
      account_holder_type,
    } = state.newPaymentSourceForm;

    function generateStripeToken() {
      return kind === "card"
        ? stripe.createToken(
            { name: "" },
            {},
            { stripe_account: organization.stripe_account_id }
          )
        : stripe.createToken(
            "bank_account",
            {
              country: "US",
              account_holder_name: `${first_name} ${last_name}`,
              currency: "usd",
              account_holder_type,
              account_number,
              routing_number,
            },
            { stripe_account: organization.stripe_account_id }
          );
    }

    dispatch({ type: "BEGIN_SUBMIT_NEW_PAYMENT_SOURCE" });
    generateStripeToken().then((stripeResponse) => {
      if (stripeResponse.error) {
        dispatch({
          type: "FAILED_SUBMIT_NEW_PAYMENT_SOURCE",
          payload: [stripeResponse.error.message],
        });
      } else {
        $.ajax({
          url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources.json`,
          method: "POST",
          data: {
            payment_source:
              kind === "card"
                ? {
                    first_name,
                    last_name,
                    email,
                    kind,
                    stripe_token_id: stripeResponse.token.id,
                    stripe_source_id: stripeResponse.token.card.id,
                    last4: stripeResponse.token.card.last4,
                    brand: stripeResponse.token.card.brand,
                  }
                : {
                    first_name,
                    last_name,
                    email,
                    kind,
                    stripe_token_id: stripeResponse.token.id,
                    stripe_source_id: stripeResponse.token.bank_account.id,
                    bank_name: stripeResponse.token.bank_account.bank_name,
                    last4: stripeResponse.token.bank_account.last4,
                  },
          },
          success: (response) => {
            dispatch({ type: "ADD_PAYMENT_SOURCE", payload: response });
            dispatch({ type: "SUCCESS_SUBMIT_NEW_PAYMENT_SOURCE" });
            handleClose();
          },
          error: (xhr) => {
            const response = $.parseJSON(xhr.responseText);
            const errors = response.errors;
            const otherErrors = response.base ? response.base.join(', ') : null;
            dispatch({
              type: "FAILED_SUBMIT_NEW_PAYMENT_SOURCE",
              payload: [errors, otherErrors].filter(n => n),
            });
          },
        });
      }
    });
  };
}

export function redirectToBankAccountCheckout() {
  return (dispatch, getState) => {
    const { resident, organization } = getState();

    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources/checkout_session.json`,
      method: "POST",
      success: (response) => {
        // An authorization denial still comes back 200, so only navigate when
        // Stripe actually handed us somewhere to go.
        if (!response || !response.url) {
          dispatch({
            type: "FAILED_SUBMIT_NEW_PAYMENT_SOURCE",
            payload: ["Unable to start the bank account setup. Please try again."],
          });
          return;
        }
        // Clear the form before leaving for Stripe: a browser Back from
        // Checkout can restore this page from cache, and a lingering
        // is_submitting leaves the modal spinning with no way to close it.
        dispatch({ type: "RESET_NEW_PAYMENT_SOURCE_FORM" });
        window.location.assign(response.url);
      },
      error: (xhr) => {
        let errors;
        try {
          errors = $.parseJSON(xhr.responseText).errors;
        } catch (e) {
          errors = null;
        }
        dispatch({
          type: "FAILED_SUBMIT_NEW_PAYMENT_SOURCE",
          payload:
            errors && errors.length
              ? errors
              : ["Unable to start the bank account setup. Please try again."],
        });
      },
    });
  };
}

export const updateNewPaymentSourceField = (payload) => {
  return {
    type: "UPDATE_NEW_PAYMENT_SOURCE_FIELD",
    payload,
  };
};
